var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-certificate",style:(_vm.businessCode?_vm.businessCodeStyle:'')},[_c('div',{staticClass:"certificate-see",domProps:{"innerHTML":_vm._s(_vm.htmls)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }